import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
} from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";
import { getAboutYouUserList } from "../../http/dashboard";
import { Button } from "antd";
import { Download } from "@mui/icons-material";

const questionsArr = [
  { title: "Sr No.", key: "idx", minWidth: "50px" },
  {
    title: "Email Address",
    key: "email",
    minWidth: "150px",
  },
  {
    title: "What is your First Name?",
    key: "firstName",
    minWidth: "150px",
  },
  {
    title: "What age range are you in?",
    key: "ageRange",
    minWidth: "200px",
  },
  {
    title: "Do you currently live in Canada?",
    key: "livingInCanada",
    minWidth: "200px",
  },
  {
    title: "How long have you lived in Canada?",
    key: "yearsLivingInCanada",
    minWidth: "200px",
  },
  {
    title: "What province or territory do you live in?",
    key: "province",
    minWidth: "200px",
  },
  {
    title: "What city or town are you living in, or closest to?",
    key: "city",
    minWidth: "250px",
  },
  {
    title: "What is your current immigration status?",
    key: "immigrationStatus",
    minWidth: "200px",
  },
  {
    title:
      "Tell us more about your family and who you will support financially in Canada.",
    key: "houseHold",
    type: "array",
    minWidth: "400px",
  },
];
export default function AboutTable(props) {
  const {
    listData,
    handleChangePage,
    page,
    totalCount,
    showDownloadReport,
    handleDownloadReport,
  } = props;
  const quesArr = showDownloadReport
    ? [
        ...questionsArr,
        {
          title: "Budget Report",
          key: "budgetReportId",
          width: "200px",
          type: "button",
        },
      ]
    : questionsArr;
  return (
    <>
      <TableContainer
        component={Paper}
        sx={{ maxHeight: "calc(100vh - 210px)", overflow: "auto" }}
      >
        <Table sx={{ minWidth: 650 }} aria-label="sticky table" stickyHeader>
          <TableHead>
            <TableRow>
              {quesArr?.map((ques) => {
                return (
                  <TableCell
                    sx={{
                      minWidth: ques?.minWidth,
                      color: "#000",
                      fontSize: "15px",
                      verticalAlign: "top",
                    }}
                  >
                    {ques?.title}
                  </TableCell>
                );
              })}
            </TableRow>
          </TableHead>
          <TableBody>
            {listData?.map((user, idx) => {
              return (
                <TableRow>
                  {quesArr?.map((item) => {
                    if (item.type != "array") {
                      return (
                        <TableCell
                          style={{
                            top: 57,
                            minWidth: item.minWidth || "200px",
                            color: "#768896",
                            fontWeight: 500,
                            fontSize: "14px",
                          }}
                        >
                          {item.type === "button" ? (
                            item.key === "budgetReportId" &&
                            user?.[item?.key] ? (
                              <Button
                                sx={{
                                  border: "1px solid #0832DE",
                                  color: "#0832DE",
                                  borderRadius: "4px",
                                  fontSize: "14px",
                                  fontWeight: 500,
                                  height: "32px",
                                }}
                                onClick={() =>
                                  handleDownloadReport(user?.[item?.key])
                                }
                              >
                                <Download />
                                <span style={{ marginLeft: "5px" }}>
                                  Download
                                </span>
                              </Button>
                            ) : (
                              "No Report Exist"
                            )
                          ) : item?.key === "idx" ? (
                            idx + 1
                          ) : item.key === "yearsLivingInCanada" && user?.[item?.key] === 'born' ?
                          'Since birth'
                        : (
                          user?.[item?.key]
                        )}
                        </TableCell>
                      );
                    }
                    return (
                      <TableCell
                        style={{
                          top: 57,
                          minWidth: item.minWidth || "200px",
                          color: "#768896",
                          fontWeight: 500,
                          fontSize: "14px",
                        }}
                      >
                        {user?.[item?.key]?.map((innerItem, idx) => {
                          return (
                            <span>
                              {innerItem?.type}{" "}
                              {innerItem?.count ? `: ${innerItem?.count}` : ""}{" "}
                              {idx + 1 != user?.[item?.key]?.length ? ", " : ""}
                            </span>
                          );
                        })}
                      </TableCell>
                    );
                  })}{" "}
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        sx={{
          width: "100%",
          "& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows":
            {
              fontSize: "14px",
            },
          "& .MuiTablePagination-selectLabel, & .MuiTablePagination-select, & .MuiTablePagination-actions .MuiIconButton-root":
            {
              color: "black",
            },
        }}
        component={"div"}
        colSpan={3}
        count={totalCount}
        rowsPerPage={10}
        page={page}
        slotProps={{
          select: {
            inputProps: {
              "aria-label": "rows per page",
            },
            native: true,
          },
        }}
        rowsPerPageOptions={[]}
        onPageChange={handleChangePage}
      />
    </>
  );
}
